import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import OnDeleteIcon from '../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../icons/OnEditIcon';
import { formatToMonthYear } from '../../../utils/dateFunctions';
import { getNameFromId } from '../../../utils/directusFunctions';

import card from '../../../commonStyles/card.module.css';

const WorkHistoryCard = ({
    employment,
    isDisabled = true,
    onEditEmployment,
    onDeleteEmployment
}) => {
    // STORE STATE
    const employmentTypeDetails = useSelector(
        (state) => state.entities.directusService.employmentTypeDetails
    );
    const reasonForLeavingDetails = useSelector(
        (state) => state.entities.directusService.reasonForLeavingDetails
    );

    // RENDER
    return (
        <div className={card.card} data-testid="employment_card">
            <div
                className={`${
                    employment.companyName?.length > 40
                        ? card.bannerTwoRowWithActions
                        : card.bannerWithActions
                }`}>
                {!isDisabled && (
                    <div className={card.bannerActions}>
                        <span className={card.editIcons} data-testid="employment_card_icons">
                            <OnEditIcon
                                onEdit={() => onEditEmployment(employment)}
                                active={!isDisabled}
                            />
                            <OnDeleteIcon
                                onDelete={() => onDeleteEmployment(employment)}
                                active={!isDisabled}
                            />
                        </span>
                    </div>
                )}
                <h6>{employment.companyName || 'Work History'}</h6>
            </div>

            <div className={card.content}>
                <p className={card.copy}>
                    <span className={card.heading}>{employment.jobTitle}</span>
                    <span className={card.normalText}>
                        {employment?.startDate ? formatToMonthYear(employment.startDate) : ''}
                        {employment?.endDate ? ` - ${formatToMonthYear(employment.endDate)}` : ''}
                    </span>
                </p>
                <p className={card.copy}>
                    <span className={card.heading}>
                        {getNameFromId(employmentTypeDetails, employment.employmentTypeId)}
                    </span>
                    <span className={card.heading}>
                        {getNameFromId(reasonForLeavingDetails, employment.reasonForLeavingId)}
                    </span>

                    {employment.description?.length > 200
                        ? employment.description.substring(0, 197) + '...'
                        : employment?.description}
                </p>
            </div>
        </div>
    );
};

WorkHistoryCard.propTypes = {
    employment: PropTypes.object,
    isDisabled: PropTypes.bool,
    onEditEmployment: PropTypes.func,
    onDeleteEmployment: PropTypes.func
};

export default WorkHistoryCard;
